<script>
import { appointmentMetaFields as metaFields } from "./metaFields";
import { Validator, } from "@/plugins/validator";
export default {
    name: "AppointmentFormTab",

    data() {

        return {
            doctors: [],
            departments: [],
            appointments: [],
            appointment: {
                id: 0,
                patientID: this.$route.params.patientID,
                visitNo: this.$route.params.visitNo,
                encounterID: this.$route.query.encounterID,
                appointmentDate: window.moment().format(`YYYY-MM-DD`),
                time: window.moment().format('HH:MM'),
                comment: ``,
                userName: this.$root.username,
                cancelled: false,
                doctorID: 0,
                clinicID: 0,
                doctor: ``,
                clinic: ``,
            },
            errors: [],
        };
    },

    watch: {

      'appointment.doctorID'() {
        if(!this.appointment.doctorID) {
          this.appointment.doctor = ``;
          return;
        }

        this.doctors.forEach(cons => {
          if(cons.id == this.appointment.doctorID) {
            this.appointment.doctor = cons.names;
          }
        });
      },

      'appointment.clinicID'() {
        if(!this.appointment.clinicID) {
          this.appointment.clinic = ``;
          return;
        }

        this.departments.forEach(dep => {
          if(dep.clinicId == this.appointment.clinicID) {
            this.appointment.clinic = dep.clinic;
          }
        });
      },
    },

    mounted() {

        Promise.all([ this.fetchDoctors(), this.fetchDepartments(), this.fetchAppointments(), ]);
    },

    methods: {

        fetchDoctors() {

            return this.$http.get(`Shared/GetActiveConsultants`).then(({ data }) => {
                    this.doctors = data;
                }).catch(() => {});
        },

        fetchDepartments() {

            return this.$http.get(`MasterData/GetClinics`).then(response => {
                this.departments = response.data;
            }).catch(() => {});
        },

        fetchAppointments() {
            let url = `MedicalFile/GetPatientAppointmentsforEncounter`;
                url += `?PatientID=${this.$route.params.patientID}`;
                url += `&VisitNo=${this.$route.params.visitNo}`;
                url += `&EncounterID=${this.$route.query.encounterID}`;

            this.$http.get(url).then(response => {
                this.appointments = response.data;
            }).catch(() => {});
        },

        saveData() {

            new Validator(this.appointment, metaFields).validate().then(() => {
                this.$root.loading = true;
                this.$http.post(`MedicalFile/PatientAppointments`, this.appointment).then(() => {
                    this.appointment = {
                        id: 0,
                        patientID: this.$route.params.patientID,
                        visitNo: this.$route.params.visitNo,
                        encounterID: this.$route.query.encounterID,
                        appointmentDate: window.moment().format(`YYYY-MM-DD`),
                        time: window.moment().format('HH:MM'),
                        comment: ``,
                        userName: this.$root.username,
                        cancelled: false,
                    };
                    this.$root.loading = false;
                    this.fetchAppointments();
                }).catch(() => { this.$root.loading = false; });
            }).catch(errors => { this.errors = errors; });
        },
    },
}
</script>
<template>
<div class="w-full flex flex-wrap">
    <div class="md:w-1/4 sm:w-full p-tiny">
        <label for="grid-doctor" class="label-control">Doctor:</label>
        <tail-select>
            <template v-slot:field>
                <select v-model="appointment.doctorID" id="grid-doctor" 
                    class="input-control input-sm text-xs">
                    <option :value="0">select consultant</option>
                    <option v-for="doc in doctors" 
                        :key="doc.id" :value="doc.id">{{ doc.names }}</option>
                </select>
            </template>
        </tail-select>
        <p class="form-text-error" 
            v-if="errors.filter(error => error.field == 'doctor').length">
                {{ errors.filter(error => error.field == 'doctor')[0].message }}</p>
    </div>
    <div class="md:w-1/4 sm:w-full p-tiny">
        <label for="grid-clinic" class="label-control">Clinic:</label>
        <tail-select>
            <template v-slot:field>
                <select v-model="appointment.clinicID" 
                    id="grid-clinic" class="input-control input-sm text-xs">
                    <option :value="0">select clinic</option>
                    <option v-for="clinic in departments" 
                        :key="clinic.clinicId" :value="clinic.clinicId">{{ clinic.clinic }}</option>
                </select>
            </template>
        </tail-select>
        <p class="form-text-error" 
            v-if="errors.filter(error => error.field == 'clinic').length">
                {{ errors.filter(error => error.field == 'clinic')[0].message }}</p>
    </div>
    <div class="md:w-1/5 sm:w-full p-tiny">
        <label for="grid-date" class="label-control">Date:</label>
        <input type="date" v-model="appointment.appointmentDate" 
            id="grid-date" class="input-control input-sm text-xs">
        <p class="form-text-error" 
            v-if="errors.filter(error => error.field == 'appointmentDate').length">
                {{ errors.filter(error => error.field == 'appointmentDate')[0].message }}</p>
    </div>
    <div class="md:w-1/5 sm:w-full p-tiny">
        <label for="grid-time" class="label-control">Time:</label>
        <input type="time" v-model.trim="appointment.time" 
            id="grid-time" class="input-control input-sm text-xs">
        <p class="form-text-error" 
            v-if="errors.filter(error => error.field == 'time').length">
                {{ errors.filter(error => error.field == 'time')[0].message }}</p>
    </div>
    <div class="md:w-1/12 sm:w-full text-right p-tiny mt-4">
        <button 
            class="btn-sm btn-primary rounded text-xs" 
            @click.stop="saveData">
                <i class="fa fa-save"></i> Save</button>
    </div>
    <div class="w-full overflow-auto">
        <table class="table table-hover">
            <thead class="bg-blue-500 text-white text-sm">
               <tr class="w-full flex">
                   <th class="p-tiny flex-1">Doctor</th>
                   <th class="p-tiny flex-1">Clinic</th>
                   <th class="p-tiny flex-1">Date</th>
                   <th class="p-tiny flex-1">Time</th>
                   <th class="p-tiny flex-1">Action</th>
               </tr> 
            </thead>
            <tbody 
                class="bg-gray-100 text-sm flex flex-col items-center overflow-auto">
                <tr v-for="(app, idx) in appointments" class="w-full flex" :key="idx">
                    <td class="p-tiny flex-1">{{ app.doctor }}</td>
                    <td class="p-tiny flex-1">{{ app.clinic }}</td>
                    <td class="p-tiny flex-1">{{ app.appointmentDate | dateFormat }}</td>
                    <td class="p-tiny flex-1">{{ app.startTime }}</td>
                    <td class="p-tiny flex-1">
                        <button 
                            class="btn-sm btn-primary text-xs" 
                            @click.prevent="appointment={ 
                                ...app, appointmentDate: $root.formatDate(app.appointmentDate), 
                                time: app.startTime }">
                                    <i class="fa fa-edit"></i></button>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</div>
</template>